<template>
  <v-card class="card-container">
    <v-dialog v-model="aboutDialog" max-width="900">
      <AboutContract :receivedContract="currentContract" :key="dialogKey" />
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Tem certeza de que deseja excluir este contrato?') }}
          </div>

          <v-btn
            :disabled="loading"
            class="ma-1"
            color="grey"
            text
            @click="deleteDialog = false"
          >
            {{ $t('Cancelar') }}
          </v-btn>

          <v-btn
            :loading="loading"
            class="ma-1"
            color="error"
            text
            @click="remove"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="deleteManyDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{
              $t('Tem certeza de que deseja excluir os contratos selecionados?')
            }}
          </div>

          <v-btn
            :disabled="loading"
            class="ma-1"
            color="grey"
            text
            @click="deleteManyDialog = false"
          >
            {{ $t('Cancelar') }}
          </v-btn>

          <v-btn
            :loading="loading"
            class="ma-1"
            color="error"
            text
            @click="removeMany"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <div class="main-toolbar mb-2">
      <div class="icon-back">
        <v-img
          src="../../../../assets/figmaIcons/white/contracts.svg"
          max-width="55%"
        ></v-img>
      </div>

      <span class="main-toolbar-title">{{ $t('Contratos') }}</span>

      <v-spacer></v-spacer>

      <v-btn
        v-show="buttonDeleteVisible"
        v-if="userType < 3"
        class="mr-2 hidden-sm-and-down quaternary-button"
        color="#A42A2AD9"
        dark
        depressed
        @click="deleteManyContracts"
      >
        {{ $t('Remover selecionados') }}
      </v-btn>

      <v-btn
        color="#BBCF20"
        dark
        depressed
        class="mr-2 hidden-sm-and-down primary-button"
        @click="generateExcel"
      >
        {{ $t('Exportar excel') }}
      </v-btn>

      <v-btn
        v-show="userType < 4 || userType >= 7"
        color="#0F3565"
        dark
        depressed
        class="hidden-sm-and-down secondary-button"
        @click="addContract"
      >
        {{ $t('Novo contrato') }}
      </v-btn>

      <v-btn
        color="#BBCF20"
        dark
        depressed
        class="ml-3 hidden-sm-and-down primary-button"
        @click="visible = !visible"
      >
        {{ $t('Filtros') }}
      </v-btn>
    </div>

    <div class="my-4 back hidden-md-and-up">
      <div class="d-flex">
        <v-spacer></v-spacer>
        <v-btn
          v-show="userType < 4 || userType >= 7"
          small
          class="hidden-md-and-up mr-2"
          color="#0F3565"
          dark
          depressed
          @click="addContract"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn
          v-show="buttonDeleteVisible"
          v-if="userType < 3"
          small
          class="hidden-md-and-up mr-2"
          color="#A42A2AD9"
          dark
          depressed
          @click="deleteManyContracts"
        >
          <v-icon>mdi-trash-can-outline</v-icon>
        </v-btn>
        <v-btn
          class="hidden-md-and-up"
          small
          depressed
          color="#BBCF20"
          dark
          @click="visible = !visible"
        >
          <v-icon> mdi-filter </v-icon>
        </v-btn>
      </div>
    </div>

    <v-expand-transition>
      <div v-show="visible" class="mb-2">
        <v-row class="ma-0" dense>
          <v-col cols="12" sm="6" md="6" lg="4">
            <label class="label">{{ $t('Instituição') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="institutionId"
              :items="institutions"
              item-value="id"
              item-text="name"
              :loading="institutionLoading"
              outlined
              disabled
              append-icon=""
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="4">
            <label class="label">{{ $t('Unidade') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="unidadeId"
              :items="unidades"
              item-value="id"
              item-text="name"
              :loading="unidadeLoading"
              :disabled="!institutionId"
              :placeholder="
                !institutionId ? $t('Selecione uma instituição') : ''
              "
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="4">
            <label class="label">{{ $t('Nº Contrato') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="contractNumber"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="4">
            <label class="label">{{ $t('Contrato') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="contractName"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6" md="6" lg="4">
            <label class="label">{{ $t('Cobertura') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="contractCoverage"
              :items="coverages"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            >
              <template v-slot:selection="{ item }">
                <span class="text-caption">
                  {{ $t(item) }}
                </span>
              </template>

              <template v-slot:item="{ item }">
                <span class="text-caption">
                  {{ $t(item) }}
                </span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="4">
            <label class="label">{{ $t('Fornecedor') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="supplierId"
              :items="suppliers"
              item-value="id"
              item-text="name"
              :loading="supplierLoading"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="9" md="9" lg="9">
            <v-row class="d-flex align-end">
              <v-col class="ma-0 py-0" cols="12" sm="5" md="5" lg="5">
                <label class="label">{{ $t('Início vigência') }}</label>
                <v-menu
                  ref="menuStartDate"
                  v-model="menuStartDate"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      hide-details="auto"
                      v-model="startDate"
                      placeholder="00/00/0000"
                      v-mask="['##/##/####']"
                      prepend-inner-icon="mdi-calendar"
                      @blur="contractStartDate = parseDate(startDate)"
                      v-bind="attrs"
                      v-on="on"
                      autocomplete="off"
                      outlined
                      class="primary-input"
                      @keyup.enter="filterTable"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    v-model="contractStartDate"
                    min="1900-01-01"
                    @change="save"
                    locale="pt"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="2" sm="1" md="1" lg="1" class="text-center">
                <span>{{ $t('até') }}</span>
              </v-col>

              <v-col class="ma-0 py-0" cols="10" sm="5" md="5" lg="5">
                <label class="label">{{ $t('Fim vigência') }}</label>
                <v-menu
                  ref="menuEndDate"
                  v-model="menuEndDate"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      hide-details="auto"
                      :disabled="!startDate"
                      v-model="endDate"
                      placeholder="00/00/0000"
                      v-mask="['##/##/####']"
                      prepend-inner-icon="mdi-calendar"
                      @blur="contractEndDate = parseDate(endDate)"
                      v-bind="attrs"
                      v-on="on"
                      autocomplete="off"
                      outlined
                      class="primary-input"
                      @keyup.enter="filterTable"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    no-title
                    v-model="contractEndDate"
                    @change="save"
                    locale="pt"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="mt-3" cols="12" sm="3" md="3" lg="3">
            <div class="d-flex align-center justify-center">
              <v-btn
                class="mx-2 secondary-button"
                color="#BBCF20"
                depressed
                @click="filterTable"
              >
                <span>{{ $t('Filtrar') }}</span>
                <v-icon class="pl-2">mdi-magnify</v-icon>
              </v-btn>

              <v-btn
                depressed
                color="#20202066"
                class="clear-button"
                @click="reset"
              >
                <span>{{ $t('Limpar') }}</span>
                <v-icon class="pl-2">mdi-cached</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>

    <div class="wrapper mobile">
      <v-data-table
        :loading="loading"
        :headers="headersMobile"
        :items="contracts"
        v-model="contractsSelected"
        :single-select="false"
        item-key="id"
        show-select
        class="main-table"
        hide-default-footer
        :items-per-page="pageSize"
        :header-props="headerProps"
        :mobile-breakpoint="330"
        :single-expand="false"
        :expanded.sync="expanded"
        @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
      >
        <template #[`item.number`]="{ item }">
          {{ item.number != null ? item.number : $t('Sem registro') }}
        </template>

        <template #[`item.supplier`]="{ item }">
          {{ supplierName(item.supplierId) }}
        </template>

        <template #[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-1"
                x-small
                color="#f5f5f5"
                dark
                @click="openAbout(item)"
                v-bind="attrs"
                v-on="on"
                depressed
              >
                <v-icon small color="#bbcf20">mdi-eye-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Detalhar') }}</span>
          </v-tooltip>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>{{ $t('Nome (apelido)') }}:</strong>
                {{ item.name != '' ? item.name : $t('Sem registro') }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>{{ $t('Cobertura') }}:</strong>
                <strong
                  v-for="(contractCoverage, i) in item.eContractCoverages"
                  :key="i"
                >
                  {{ coverages[contractCoverage] }}
                </strong>
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>{{ $t('Data início') }}:</strong>
                {{
                  item.startDate != null
                    ? formatDate(item.startDate)
                    : $t('Sem registro')
                }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>{{ $t('Data fim') }}:</strong>
                {{
                  item.endDate != null
                    ? formatDate(item.endDate)
                    : $t('Sem registro')
                }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p v-show="userType < 4 || userType >= 7">
                <strong>{{ $t('Ações') }}: </strong>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-show="userType != 3"
                      class="ma-1"
                      color="#0F3565"
                      depressed
                      dark
                      @click="editContract(item)"
                      v-bind="attrs"
                      v-on="on"
                      x-small
                    >
                      <v-icon small> mdi-pencil-outline </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('Editar') }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-show="userType != 3"
                      class="ma-1"
                      :color="
                        item.uploadDocuments.length > 0 ? '#BBCF20' : '#F5F5F5'
                      "
                      dark
                      @click.stop="uploadDocument(item)"
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      depressed
                    >
                      <span style="font-size: 0.9rem">
                        {{
                          item.uploadDocuments.length > 0
                            ? item.uploadDocuments.length
                            : ''
                        }}
                      </span>
                      <v-icon
                        small
                        :class="item.uploadDocuments.length > 0 ? 'ml-1' : ''"
                        :color="
                          item.uploadDocuments.length > 0 ? '#fff' : '#BBCF20'
                        "
                      >
                        mdi-file-document-multiple-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('Documentos Anexados') }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-if="userType < 3 || userType == 8"
                      class="ma-1"
                      x-small
                      color="#A42A2AD9"
                      style="font-weight: bold"
                      dark
                      v-bind="attrs"
                      @click="deleteContract(item)"
                      v-on="on"
                      depressed
                    >
                      <v-icon small> mdi-trash-can-outline </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('Excluir') }}</span>
                </v-tooltip>
              </p>
            </v-col>
          </td>
        </template>
      </v-data-table>
      <div class="pagination">
        <div class="item-pagination block-one">
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="btn"
                depressed
                color="#C0C0C0"
                small
              >
                qtd: {{ pageSize }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(size, i) in sizes"
                :key="i"
                @click="pageSize = size"
              >
                <v-list-item-title>{{ size }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <div class="registros" v-if="totalItensOnPage">
            <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span> <br />
            <!-- <span>
              Selecionados:
              {{ contractsSelected.length }}
            </span> -->
          </div>
        </div>

        <div class="item-pagination block-two">
          <v-pagination
            class="pagination-item"
            v-model="page"
            :length="totalPages"
            :total-visible="3"
          ></v-pagination>
        </div>
      </div>
    </div>

    <div class="wrapper desktop">
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="contracts"
        v-model="contractsSelected"
        :single-select="false"
        item-key="id"
        show-select
        class="main-table"
        hide-default-footer
        hide-default-header
        :header-props="headerProps"
        :items-per-page="pageSize"
        @click:row="editContract"
      >
        <template #header="{ props, on }">
          <thead>
            <tr>
              <th
                class="text-center"
                v-for="header in props.headers"
                :key="header.value"
              >
                <v-simple-checkbox
                  v-if="header.value === 'data-table-select'"
                  v-model="props.everyItem"
                  :indeterminate="props.someItems && !props.everyItem"
                  color="purple"
                  @input="on['toggle-select-all']"
                ></v-simple-checkbox>

                <div>
                  <v-hover v-slot="{ hover }">
                    <div>
                      <span>{{ $t(header.text) }}</span>
                      <v-icon
                        v-if="
                          hover &&
                          header.value != 'data-table-select' &&
                          header.value != 'actions'
                        "
                        color="white"
                        class="mx-2"
                        @click="on.sort(header.value)"
                      >
                        {{
                          props.options.sortBy.includes(header.value)
                            ? `mdi-chevron-down`
                            : `mdi-chevron-up`
                        }}
                      </v-icon>
                    </div>
                  </v-hover>
                </div>
              </th>
            </tr>
          </thead>
        </template>

        <template #[`item.name`]="{ item }">
          {{ item.name != '' ? item.name : $t('Sem registro') }}
        </template>

        <template #[`item.number`]="{ item }">
          {{ item.number != null ? item.number : $t('Sem registro') }}
        </template>

        <template #[`item.coverage`]="{ item }">
          <span
            v-if="
              item.eContractCoverages && item.eContractCoverages.length == 0
            "
          >
            Sem registros
          </span>

          <span
            v-for="(contractCoverage, i) in item.eContractCoverages"
            :key="i"
          >
            {{ coverages[contractCoverage] }}
            <span v-if="i != item.eContractCoverages.length - 1">,</span>
          </span>
        </template>

        <template #[`item.supplier`]="{ item }">
          {{ supplierName(item.supplierId) }}
        </template>

        <template #[`item.startDate`]="{ item }">
          {{
            item.startDate != null
              ? formatDate(item.startDate)
              : $t('Sem registro')
          }}
        </template>

        <template #[`item.endDate`]="{ item }">
          {{
            item.endDate != null ? formatDate(item.endDate) : $t('Sem registro')
          }}
        </template>

        <template #[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-show="userType < 4 || userType >= 7"
                class="ma-1"
                color="#0F3565"
                dark
                depressed
                @click.stop="editContract(item)"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon small> mdi-pencil-outline </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Editar') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-1"
                small
                color="#f5f5f5"
                style="font-weight: bold"
                dark
                depressed
                @click.stop="openAbout(item)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="#bbcf20">mdi-eye-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Detalhar') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-show="userType < 4 || userType >= 7"
                class="ma-1"
                :color="item.uploadDocuments.length > 0 ? '#BBCF20' : '#F5F5F5'"
                dark
                depressed
                @click.stop="uploadDocument(item)"
                v-bind="attrs"
                v-on="on"
                small
              >
                <span style="font-size: 0.9rem">
                  {{
                    item.uploadDocuments.length > 0
                      ? item.uploadDocuments.length
                      : ''
                  }}
                </span>
                <v-icon
                  small
                  :class="item.uploadDocuments.length > 0 ? 'ml-1' : ''"
                  :color="item.uploadDocuments.length > 0 ? '#fff' : '#BBCF20'"
                >
                  mdi-file-document-multiple-outline
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Documentos Anexados') }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <div class="pagination">
        <div class="item-pagination block-one">
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="btn"
                depressed
                color="#C0C0C0"
                small
              >
                qtd: {{ pageSize }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(size, i) in sizes"
                :key="i"
                @click="pageSize = size"
              >
                <v-list-item-title>{{ size }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <div class="registros" v-if="totalItensOnPage">
            <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span> <br />
            <!-- <span>
              Selecionados:
              {{ contractsSelected.length }}
            </span> -->
          </div>
        </div>

        <div class="item-pagination block-two">
          <v-pagination
            class="pagination-item"
            v-model="page"
            :length="totalPages"
            :total-visible="3"
          ></v-pagination>
        </div>
      </div>
    </div>
  </v-card>
</template>

<style scoped lang="scss">
@import '@/sass/variables.scss';
.mobile {
  display: none;
  @media (max-width: $tablet-1) {
    display: block;
  }
}
.desktop {
  @media (max-width: $tablet-1) {
    display: none;
  }
}
.v-application .primary--text {
  color: #707070 !important;
  caret-color: #707070 !important;
}

.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}

.v-picker.v-card
  >>> .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(
    .v-btn--outlined
  ) {
  background-color: #ffffff;
}
</style>

<script>
import ApiService from '../../../../services/ApiService'
import AboutContract from './AboutContract.vue'
import Utils from '../../../../Utils/FormatDate'

export default {
  components: {
    AboutContract,
  },

  async created() {
    this.userType = JSON.parse(localStorage.getItem('institution')).userType
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.getInstitutions()

    if (this.userType > 1) {
      await this.getUserUnidades()
    } else {
      await this.getUnidades()
    }

    this.getSuppliers()
    this.updateTable()
  },

  data: () => ({
    errorMessage: '',
    totalItensOnPage: 0,
    expanded: [],
    menuStartDate: false,
    menuEndDate: false,
    visible: false,
    dialog: false,
    editDialog: false,
    aboutDialog: false,
    deleteDialog: false,
    deleteManyDialog: false,
    buttonDeleteVisible: false,
    dialogKey: false,
    loading: false,
    institutionLoading: false,
    unidadeLoading: false,
    supplierLoading: false,
    error: false,
    startDate: null,
    endDate: null,
    minDate: null,
    institutionId: null,
    institutions: [],
    unidadeId: 0,
    unidades: [],
    supplierId: 0,
    suppliers: [],
    currentSupplier: {},
    contractsSelected: [],
    contracts: [],
    currentContract: {},
    userType: null,
    coverages: [
      'Validação de equipamentos',
      'Outros',
      'Manutenção preventiva',
      'Manutenção corretiva',
      'Locação / Comodato',
      'Corretiva e Preventiva',
      'Calibração',
    ],
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    totalItems: 0,
    filter: {
      page: 1,
      pageSize: 10,
      number: null,
      name: null,
      startDate: null,
      endDate: null,
      institutionId: null,
      unidadeId: 0,
      supplierId: 0,
      coverage: null,
    },
    contractNumber: null,
    contractName: null,
    contractStartDate: null,
    contractEndDate: null,
    contractUnidadeId: 0,
    contractSupplierId: 0,
    contractCoverage: null,
    headers: [
      {
        text: 'Contrato',
        align: 'center',
        value: 'name',
      },
      {
        text: 'Nº Contrato',
        align: 'center',
        value: 'number',
      },
      {
        text: 'Cobertura',
        align: 'center',
        value: 'coverage',
        sortable: false,
      },
      {
        text: 'Fornecedor',
        align: 'center',
        value: 'supplier',
      },
      {
        text: 'Data Início',
        align: 'center',
        value: 'startDate',
        sortable: false,
      },
      {
        text: 'Data Fim',
        align: 'center',
        value: 'endDate',
        sortable: false,
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false,
        width: 200,
      },
    ],
    headersMobile: [
      {
        text: 'Nº Contrato',
        align: 'center',
        value: 'number',
      },
      {
        text: 'Fornecedor',
        align: 'center',
        value: 'supplier',
        sortable: false,
      },
      {
        text: 'Ações',
        value: 'actions',
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    apiService: new ApiService(),
  }),

  methods: {
    generateExcel() {
      this.page = 1
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.number = this.contractNumber
      this.filter.name = this.contractName
      this.filter.startDate = this.contractStartDate
      this.filter.endDate = this.contractEndDate
      this.filter.unidadeId = this.unidadeId
      this.filter.supplierId = this.supplierId
      this.filter.coverage = this.coverages.indexOf(this.contractCoverage)
      let now = new Date()
      var filename = `Contrato_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`

      this.apiService.post('contract/excel', this.filter).then((response) => {
        response.content = `data:application/octet-stream;base64,${response.content}`
        const link = document.createElement('a')
        link.href = response.content
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
      })
    },
    async getUserUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/listByUserAndInstitution/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    addContract() {
      this.$router.push({ name: 'newContract' })
    },

    editContract(contract) {
      if (this.userType == 4) return
      if (contract.length > 0) {
        this.currentContract = contract[0]
      } else {
        this.currentContract = contract
      }
      this.$router.push(`editContract/${this.currentContract.id}`)
    },

    uploadDocument(contract) {
      sessionStorage.clear()
      this.currentContract = contract
      sessionStorage.setItem('contract', JSON.stringify(this.currentContract))
      this.$router.push({ path: '/uploadDocument' })
    },

    deleteContract(contract) {
      this.currentContract = contract
      this.dialogKey = !this.dialogKey
      this.deleteDialog = true
    },

    deleteManyContracts() {
      this.dialogKey = !this.dialogKey
      this.deleteManyDialog = true
    },

    openAbout(contract) {
      this.currentContract = contract
      this.dialogKey = !this.dialogKey
      this.aboutDialog = true
    },

    closeDialog() {
      this.dialog = false
      this.editDialog = false
      this.aboutDialog = false

      this.updateTable()
    },

    supplierName(value) {
      const supplier = this.suppliers.find((supplier) => supplier.id === value)

      if (supplier) {
        return supplier.name
      } else {
        return this.$t('Sem registro')
      }
    },

    filterTable() {
      this.page = 1
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.number = this.contractNumber
      this.filter.name = this.contractName
      this.filter.startDate = this.contractStartDate
      this.filter.endDate = this.contractEndDate
      this.filter.unidadeId = this.unidadeId
      this.filter.supplierId = this.supplierId
      this.filter.coverage = this.coverages.indexOf(this.contractCoverage)

      this.updateTable()
    },

    async updateTable() {
      this.loading = true
      this.filter.institutionId = this.institutionId

      await this.apiService
        .post('contract/filteredList', this.filter)
        .then((response) => {
          this.totalPages = response.content.pager.totalPages
          this.contracts = response.content.contracts
          this.totalItems = response.content.pager.totalItems
          this.totalItensOnPage = response.content.contracts.length
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    async remove() {
      this.loading = true

      await this.apiService
        .delete('contract/delete', this.currentContract)
        .then(() => {
          this.updateTable()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.loading = false
      this.deleteDialog = false
    },

    async removeMany() {
      this.loading = true

      await this.apiService
        .delete('contract/deleteMany', this.contractsSelected)
        .then(() => {
          this.updateTable()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.loading = false
      this.deleteManyDialog = false
      this.buttonDeleteVisible = false
      this.contractsSelected = []
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService.get('institution/list').then((response) => {
        this.institutions = response.content
        this.institutionLoading = false
      })
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getSuppliers() {
      this.supplierLoading = true

      await this.apiService
        .get(`supplier/list/${this.institutionId}`)
        .then((response) => {
          this.suppliers = response.content
          this.supplierLoading = false
        })
    },

    formatDate(date) {
      return Utils.moment(date)
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    save(date) {
      this.startDate = this.formatInputDate(this.contractStartDate)
      this.$refs.menuStartDate.save(date)
      this.minDate = new Date(this.contractStartDate)
        .toISOString()
        .substr(0, 10)
      this.endDate = this.formatInputDate(this.contractEndDate)
      this.$refs.menuEndDate.save(date)
    },

    reset() {
      this.contractNumber = null
      this.contractName = null
      this.contractStartDate = null
      this.startDate = null
      this.contractEndDate = null
      this.endDate = null
      this.contractUnidadeId = 0
      this.institutionId = this.userType > 1 ? this.institutionId : null
      this.unidadeId = this.userType > 1 ? this.unidadeId : null
      this.unidadeId = 0
      this.contractSupplierId = 0
      this.supplierId = 0
      this.contractCoverage = -1
      this.filter = {
        page: 1,
        pageSize: 10,
        number: null,
        name: null,
        startDate: null,
        endDate: null,
        unidadeId: 0,
        supplierId: 0,
        coverage: null,
      }
      this.updateTable()
    },
  },

  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize
      this.updateTable()
    },

    page() {
      this.filter.page = this.page
      this.updateTable()
    },

    contractsSelected() {
      this.buttonDeleteVisible = this.contractsSelected.length > 0
    },
  },
}
</script>
